import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Grid, LinearProgress, Divider as MuiDivider, Typography } from '@mui/material'

import { spacing } from '@mui/system'
import { styled } from '@mui/material/styles'
import { useLoaderData } from 'react-router'
import InvestorHistory from './InvestorHistory'
import InvestorYearlyOverview from './InvestorYearlyOverview'
import { WatchListButton } from '../components/WatchListButton'
import { useLogUserEvent } from '../../hooks/useLogUserEvent'
import { USER_EVENT_TYPES } from '@finance-lab/utils/types'

const Divider = styled(MuiDivider)(spacing)

function InvestorDetails() {
    const investorDetails = useLoaderData()

    useLogUserEvent(USER_EVENT_TYPES.SHOW_INVESTOR, { id: investorDetails.id })

    if (!investorDetails) {
        return <LinearProgress />
    }

    return (
        <>
            <Helmet title={investorDetails.name} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'inline',
                }}
            >
                {investorDetails.name}
                <WatchListButton
                    entityId={investorDetails.id}
                    isInWatchList={!!investorDetails.isInWatchList}
                    type='Investor'
                />
            </Typography>
            <Divider my={6} />
            <Grid container spacing={6}>
                <Grid size={12}>
                    <InvestorYearlyOverview investor={investorDetails} />
                </Grid>
                <Grid size={12}>
                    <InvestorHistory investor={investorDetails} />
                </Grid>
            </Grid>
        </>
    )
}

export default InvestorDetails
